import classNames from "classnames";
import { Link } from "gatsby";
import React from "react";

export interface PageEmbedRendererProps {
  linkTitle: string;
  locale: "en" | "nb";
  pageType: string | null;
  slug: string;
  title: string;
  isInline: boolean;
}

export const PageEmbedRenderer: React.FC<PageEmbedRendererProps> = (props) => {
  const { linkTitle, locale, pageType, slug, title, isInline } = props;
  const pageTypePath = `/${pageType ? pageType + "/" : ""}${
    slug === "index" ? "" : slug
  }`;
  const prefix = `/${locale}`;
  const path = `${prefix}${pageTypePath}`;

  return (
    <Link
      to={path}
      className={classNames(
        isInline
          ? "inline-block"
          : "servicesButton mt-50px inline-block !text-coal !no-underline",
      )}
    >
      {linkTitle || title}
    </Link>
  );
};
